import { Component, HostBinding, Input } from '@angular/core';

const BASE_SIZE = 100;

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  host: {
    role: 'progressbar',
    'aria-valuemin': '0',
    'aria-valuemax': '100',
  },
})
export class SpinnerComponent {
  @Input() diameter = BASE_SIZE;
  @Input() strokeWidth?: number;

  @HostBinding('style.width.px')
  @HostBinding('style.height.px')
  get size(): number {
    return this.diameter;
  }

  /** Strichbreite in viewBox-Einheiten, damit sie wie bei Material 10 % des Durchmessers bleibt. */
  get viewBoxStrokeWidth(): number {
    return ((this.strokeWidth ?? this.diameter / 10) / this.diameter) * BASE_SIZE;
  }
}
